/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/jsx-pascal-case */
/* eslint-disable @typescript-eslint/quotes */
/* eslint-disable react/jsx-curly-brace-presence */
/* eslint-disable no-nested-ternary */
import React, { useState, useEffect, useCallback } from 'react';
import {
  Box,
  Button,
  Modal,
  ModalOverlay,
  ModalHeader,
  ModalContent,
  ModalBody,
  ModalCloseButton,
  ModalFooter,
  chakra as C,
} from '@chakra-ui/react';
import styled from '@emotion/styled';
import { CheckTreePicker } from 'rsuite';

import { useAddUsersToGroup, useConnections } from '../../../api';
import { showNotification } from '../../notification';

const ClassroomSelectWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  margin: 15px 0;
  .rs-picker-check {
    flex-grow: 1;
  }
  .rs-picker-toggle-wrapper {
    flex-grow: 1;
    max-width: calc(100% - 40px);
    margin: 0 auto;
  }
`;
interface PickerOption {
  label: string;
  value: string;
  selected?: boolean;
  children?: PickerOption[];
}
interface SonarAddUsersModalProps {
  isAddUsersModalOpen: boolean;
  onCloseAddUsersModal: () => void;
  Styles: Record<string, any>;
  group: any;
  episodeId: string;
}
export const SonarAddUsersModal = ({
  isAddUsersModalOpen,
  onCloseAddUsersModal,
  Styles,
  group,
  episodeId,
}: SonarAddUsersModalProps) => {
  const { data: { connections, classrooms } = {} } = useConnections();
  const { group_members: members }: { group_members: any[] } = group;
  const existingMembers = members.map((u: any) => u.id);
  const [pickerList, setPickerList] = useState<PickerOption[]>([]);
  const [selectedPicks, setSelectedPicks] = useState<string[]>([]);
  const { mutate: addUsers, isLoading: addUsersLoading } = useAddUsersToGroup(
    episodeId
  );

  const resetPickerOptions = () => {
    if (classrooms) {
      const classroomIds = Object.keys(classrooms);
      const options = classroomIds.map((classroomId) => {
        const { classroom, users } = classrooms[classroomId];
        const classroomChildren = users
          .filter((u: any) => !existingMembers.includes(u.id))
          .map((u: any) => {
            return {
              label: u.username,
              value: `class__${u.id}`,
            };
          });
        return {
          label: classroom.name,
          value: classroom.id,
          children: classroomChildren,
        };
      });
      setPickerList([...options]);
    }
  };

  const handlePickerChange = (values: string[]) => {
    const newPicks = values;
    const selectedClassrooms = values.filter(
      (id) => id.indexOf('ind__') === -1 && id.indexOf('class__') === -1
    );
    if (!!selectedClassrooms?.length) {
      selectedClassrooms.forEach((parentClassroomId) => {
        const classroomStudents: string[] = [];
        const classroom = pickerList.find(
          ({ value }) => value === parentClassroomId
        );
        if (classroom?.children) {
          classroom.children.forEach((student) => {
            classroomStudents.push(student.value);
          });
          newPicks.push(...classroomStudents);
        }
      });
    }
    setSelectedPicks([...Array.from(new Set(newPicks))]);
  };

  useEffect(() => {
    if (classrooms) {
      resetPickerOptions();
    }
  }, [classrooms]);

  const onAddUsers = useCallback(async () => {
    if (!!selectedPicks.length) {
      await addUsers({
        group_id: group.id,
        episode_id: episodeId,
        invitee_ids: selectedPicks,
      });
      showNotification({
        type: 'success',
        title: 'Users have been invited/added to the group!',
        message: 'Woohoo! Your sonar learning group just got bigger.',
        duration: 3000,
      });
      resetPickerOptions();
      const clearBtn = document.getElementsByClassName(
        'rs-picker-toggle-clean'
      )[0] as HTMLAnchorElement;
      clearBtn.click();
      onCloseAddUsersModal();
    }
  }, [episodeId, selectedPicks, group, resetPickerOptions]);

  return (
    <Modal
      closeOnOverlayClick={false}
      isOpen={isAddUsersModalOpen}
      onClose={onCloseAddUsersModal}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Add group members</ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={4}>
          <Box>
            <C.div fontSize="md" textAlign="center">
              Invite more learners to group:
            </C.div>
            <Box {...Styles.GroupName}>{group.name}</Box>

            <Box
              borderTop="2px solid"
              borderColor="gray.200"
              as="div"
              fontSize="sm"
              textAlign="center"
              px={3}
              pt={6}
              mt={6}
              fontWeight="normal"
            >
              Select students/classrooms to add to the group:
              <ClassroomSelectWrapper>
                <CheckTreePicker
                  size="lg"
                  uncheckableItemValues={['2']}
                  onChange={handlePickerChange}
                  cascade
                  data={pickerList}
                />
              </ClassroomSelectWrapper>
            </Box>
          </Box>
        </ModalBody>

        <ModalFooter>
          <Button
            isDisabled={!selectedPicks.length}
            isLoading={!!addUsersLoading}
            onClick={onAddUsers}
            colorScheme="primary"
            mr={3}
          >
            Add Users
          </Button>
          <Button onClick={onCloseAddUsersModal}>Cancel</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
